import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import logger from './middleware/logger';
import reports from './components/Reports/state';
import speech from './components/Reader/Speech/state/reducers';
import {studentPreChecks, addStudentPreChecksMiddlewareListeners} from './components/StudentPreChecks/index'
import readerManager from './components/Reader/ReaderManagerEvents/ReaderManagerSlice'
import { createListenerMiddleware, configureStore } from '@reduxjs/toolkit';
import readerVideo from './components/Reader/Video/readerVideoSlice';
import tutorAssignment from './features/tutor_assignment/tutorAssignmentSlice/tutorAssignmentSlice';


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const listenerMiddleware = createListenerMiddleware();
addStudentPreChecksMiddlewareListeners(listenerMiddleware)

let store;
const reducers = combineReducers({
  reports,
  speech,
  studentPreChecks,
  readerVideo,
  readerManager,
  tutorAssignment
});

if(process.env.NODE_ENV == 'production'){
  store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(listenerMiddleware.middleware).prepend(thunk)
  });
}else{
  store = configureStore({
    reducer: reducers,
    enhancers: composeEnhancers,
    middleware: (getDefaultMiddleware) => 
      getDefaultMiddleware()
        .prepend(thunk)
          .prepend(listenerMiddleware.middleware)
  });
}


export { listenerMiddleware };
export default store;
